<template lang="pug">
section.menu-lateral
    span.sair-btn
        hr
        i.collapse-arrow.el.el-icon-arrow-right(
            v-if='isCollapse',
            @click='changeCollapse'
        )
        i.collapse-arrow.el.el-icon-arrow-left(v-else, @click='changeCollapse')
            span.text {{ $t('mensagens.comuns.esconderMenu') }}

    .menu-lateral-container
        el-menu.el-menu(
            :default-active='buscarIndexRota',
            @open='',
            @close='',
            :collapse='isCollapse'
        )
            div(v-for='(button, index) in botoesOrdenados')
                el-menu-item(
                    :index='criarIndex(index)',
                    @click='goTo(button[0].route)',
                    :key='button[0].name',
                    :class='index === 8 ? "label-novo" : ""',
                    v-if='button[0].submenus.length === 0'
                )
                    i(:class='button[0].iconClass')
                    .title(slot='title')
                        span(
                            v-for='palavra in textoBotaoInternacionalizado(button[0].name)'
                        )
                            |
                            | {{ palavra }}
                    span.label-novo(
                        v-if='verificaSeNovoModulo(button[0].name) && isCollapse'
                    ) {{ $t('mensagens.comuns.novo') }}
                    span.label-novo(
                        v-if='verificaSeNovoModulo(button[0].name) && !isCollapse',
                        style='width: 20%'
                    ) {{ $t('mensagens.comuns.novo') }}

                el-submenu(
                    :index='criarIndex(index)',
                    :key='button[0].name',
                    v-if='button[0].submenus.length > 0'
                )
                    template(slot='title')
                        i(:class='button[0].iconClass')
                        span.title(
                            slot='title',
                            v-for='palavra in button[0].name.split(" ")'
                        )
                            |
                            | {{ palavra }}

                    el-menu-item(
                        v-for='(button1, index1) in button[0].submenus',
                        :index='criarSubIndex(index, index1)',
                        @click='goTo(button1.componentOptions.actions[0][0].route)',
                        :key='button1.componentOptions.actions[0][0].name'
                    )
                        i(
                            :class='button1.componentOptions.actions[0][0].iconClass'
                        )
                        .title(slot='title')
                            span(
                                v-for='palavra in button1.componentOptions.actions[0][0].name.split(" ")'
                            )
                                |
                                | {{ palavra }}
</template>

<script>
import FloatBox from '@/components/layout/FloatBox';

export default {
    name: 'MenuLateral',

    extends: FloatBox,

    data() {
        return {
            isCollapse: true,
            rotaAnterior: '',
            nameRotaAnterior: ''
        };
    },

    watch: {
        $route(to, from) {
            this.rotaAnterior = from.path;
            this.nameRotaAnterior = from.name;
            if (this.$route.path.startsWith('/operacao') || this.$route.path.startsWith('/dashboard-monitoramento')) {
                setTimeout(() => {
                    const icons = document.querySelectorAll('i.lyra-icon.lyra-money-alt');
                    icons.forEach(icon => {
                        const div = icon.parentNode;
                        const li = div.parentNode;
                        li.querySelector('div').classList.add('hover-operacao');
                    });
                }, 500);
            } else {
                setTimeout(() => {
                    const icons = document.querySelectorAll('i.lyra-icon.lyra-money-alt');
                    icons.forEach(icon => {
                        const div = icon.parentNode;
                        const li = div.parentNode;
                        li.querySelector('div').classList.remove('hover-operacao');
                    });
                }, 500);
            }
        }
    },

    computed: {
        botoesOrdenados() {
            const ordemDosBotoes = [
                'Início',
                'SIG',
                'Pessoa',
                'Território',
                'Diagnóstico Socioambiental',
                'Pré-Análise de Crédito',
                'Monitoramento',
                'Monitoramento Socioambiental',
                'Monitoramento Agrícola',
                'Operação',
                'InteligenciaTerritorial'
            ];

            const botoesNoFinal = [
                'Laudos',
                'Noticias',
                'Usuários',
                'Operação CDA-WA',
                'MRV - Carbono'
            ];

            const uniqueButtons = [];
            const buttonNames = new Set();

            this.buttons.forEach(buttonArray => {
                const button = buttonArray[0];
                if (!buttonNames.has(button.name)) {
                    buttonNames.add(button.name);
                    uniqueButtons.push(buttonArray);
                }
            });
            const filteredButtons = uniqueButtons.filter(button => {
                return this.buttons.some(newButtonArray => newButtonArray[0].name === button[0].name);
            });

            const botoesOrdenados = [];
            const botoesNaoOrdenados = [];
            const botoesNoFinalOrdenados = [];

            filteredButtons.forEach(button => {
                if (button[0].name && ordemDosBotoes.includes(button[0].name)) {
                    botoesOrdenados.push(button);
                } else if (
                    button[0].name &&
                    botoesNoFinal.includes(button[0].name)
                ) {
                    botoesNoFinalOrdenados.push(button);
                } else {
                    botoesNaoOrdenados.push(button);
                }
            });

            const sortedBotoesOrdenados = botoesOrdenados.sort((a, b) => {
                const nameA = a[0].name;
                const nameB = b[0].name;
                const indexA = ordemDosBotoes.indexOf(nameA);
                const indexB = ordemDosBotoes.indexOf(nameB);
                return indexA - indexB;
            });

            return [
                ...sortedBotoesOrdenados,
                ...botoesNaoOrdenados,
                ...botoesNoFinalOrdenados
            ];
        },

        buscarIndexRota: function () {
            this.botoesOrdenados.forEach(botao => {
                if (botao[0].submenus === undefined) {
                    botao[0].submenus = [];
                }
            });

            let rota = this.$route.name;

            let index = -1;

            if ((this.$route.path && this.rotaAnterior) !== '/' && this.$route.path.startsWith(this.rotaAnterior)) {
                    index = this.botoesOrdenados.findIndex(item => {
                    return item[0].route === this.nameRotaAnterior;
                });
                } else {
                    index = this.botoesOrdenados.findIndex(item => {
                        return item[0].route === rota;
                    });
                }

            let indexSubmenu = -1;
            let indexMenuPrincipalSubmenu = '10-';

            this.botoesOrdenados.forEach((item, idx) => {
                if (item[0].submenus.length > 0) {
                    indexMenuPrincipalSubmenu = idx.toString() + '-';
                    indexSubmenu = item[0].submenus.findIndex(submenu => {
                        return (
                            submenu.componentOptions.actions[0][0].route ===
                            rota
                        );
                    });
                }
            });

            if (indexSubmenu >= 0) {
                return indexMenuPrincipalSubmenu + indexSubmenu.toString();
            }

            if (index || index === 0) {
                return index.toString();
            }
            return '';
        }
    },

    methods: {
        nomeBotao(key) {
            return this.$t(key);
        },

        criarIndex(index) {
            return index.toString();
        },

        criarSubIndex(index, index1) {
            return index.toString() + '-' + index1.toString();
        },

        changeCollapse() {
            if (this.isCollapse) {
                this.isCollapse = false;
            } else {
                this.isCollapse = true;
            }
        },

        goTo(route) {
            if (this.$route.name !== route) {
                const urlRegex = /^(http|https):\/\/[^ "]+$/;
                if (urlRegex.test(route)) {
                    window.open(route, '_blank');
                } else if (this.$router.history.current.name !== route) {
                    this.$router.push({ name: route });
                }
            }
            this.isCollapse = true;
        },

        textoBotaoInternacionalizado(titulo) {
            const tituloNormalizado = titulo
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9 ]/g, '');
            const tituloCamelCase = tituloNormalizado
                .split(' ')
                .map((palavra, indice) =>
                    indice === 0
                        ? palavra.toLowerCase()
                        : palavra.charAt(0).toUpperCase() +
                          palavra.slice(1).toLowerCase()
                )
                .join('');

            let tituloTraduzido = this.$t(
                `mensagens.menuLateral.${tituloCamelCase}`
            );

            if (
                (tituloTraduzido === 'Pré-Análise de Crédito' ||
                 tituloTraduzido === 'Pre-Análisis de Crédito')
            ) {
                let indexOfDe = tituloTraduzido.indexOf(' de ');
                if (indexOfDe !== -1) {

                    let part1 = tituloTraduzido.substring(0, indexOfDe + 3);
                    let part2 = tituloTraduzido.substring(indexOfDe + 4);
                    return [part1, part2];
                }
            }

            const palavras = tituloTraduzido.split(' ');
            return palavras;
        },

        verificaSeNovoModulo(titulo) {
            const modulosNovos = [
                'Monitoramento Socioambiental',
                'Monitoramento Agrícola',
                'Pré-Análise de Crédito',
                'Inteligência Territorial'
            ];
            return modulosNovos.includes(titulo);
        }
    }
};
</script>

<style lang="scss">
.menu-lateral {
    position: fixed;
    z-index: 200;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    background-color: var(--primary);
    height: 100vh;
    color: var(--white);
    padding-top: 70px;
    box-shadow: 4px 0 5px 0 rgba(0, 65, 60, 0.2);

    .menu-lateral-container {
        overflow-x: hidden;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-thumb {
            border: 2px solid var(--white);
        }
    }

    &::before {
        content: '';
        position: absolute;
        width: 32px;
        height: 15px;
        top: 65px;
        right: -32px;
        border-top-left-radius: 32px;
        border-bottom-right-radius: 40px;
        -webkit-box-shadow: -20px -20px 0 var(--primary);
        box-shadow: -14px -3px 0 var(--primary);
        z-index: -1;
    }

    .el-menu:not(.el-menu--collapse) {
        width: 200px;

        &::before {
            content: '';
            position: absolute;
            width: 32px;
            height: 15px;
            top: -5px;
            right: -32px;
            border-radius: 32px 10px 40px 10px;
            -webkit-box-shadow: -20px -20px 0 var(--primary);
            box-shadow: -14px -3px 0 var(--primary);
            z-index: -1;
        }
    }

    .el-menu {
        width: 70px;
        background-color: var(--primary) !important;
        border: 0;
    }

    .el-menu-item {
        color: var(--white);
        border: 0;
        margin: 2px 5px;
        transition: all 0.1s ease-in-out;
        border-radius: 5px;
        display: flex;

        .title {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            line-height: 2px;

            span:not(:first-child) {
                margin: -8px 2px 2px;
            }
        }

        i {
            color: var(--white);
            font-size: 40px;
            margin-right: 10px;
            margin-left: -3px;

            &:hover {
                color: var(--primary);
            }

            &::before {
                margin-top: 0;
                margin-bottom: 5px;
            }
        }

        &:hover,
        &:focus {
            background-color: var(--secondary);
            color: var(--color-button-hover);

            i {
                color: var(--color-button-hover);
            }
        }

        &:hover i:before {
            background-color: var(--white) !important;
        }

        &.is-active {
            background-color: var(--secondary);
            color: var(--primary);

            i {
                color: var(--primary);
            }

            .lyra-icon::before {
                content: '';
                background-color: var(--primary);
            }
        }
        .lyra-territorio::before,
        .lyra-territorio-monitorado::before,
        .lyra-hectare-monitorado::before,
        .lyra-diagnostico-socio::before,
        .lyra-laudos::before {
            content: '';
            height: 2.2rem !important;
            width: 1.8rem !important;
        }
        .label-novo {
            position: absolute;
            top: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 55%;
            height: 25%;
            background-color: var(--danger);
            color: var(--white);
            font-size: 9px;
            font-weight: 600;
            border-radius: 12px;
        }
    }

    .el-submenu {
        color: var(--white);
        list-style: none;
        margin: 0;
        padding-left: 0;
        transition: all 0.1s ease-in-out;

        .el-menu-item {
            min-width: 180px;
        }
    }

    .el-submenu__title {
        border: 0;
        transition: all 0.3s ease-in-out;
        border-radius: 5px;
        height: 56px;
        line-height: 50px;
        font-size: 40px;
        color: #303133;
        margin: 0px 5px;
        list-style: none;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        white-space: nowrap;
        background-color: var(--primary);

        i {
            vertical-align: middle;
            margin-right: 8px;
            margin-left: -3px;
            text-align: end;
            font-size: 30px;
            color: var(--white);
        }

        i.el-submenu__icon-arrow.el-icon-arrow-down {
            font-size: 14px;
        }

        .title {
            color: var(--white);
            font-size: 14px;

            span:not(:first-child) {
                margin: 2px;
                margin-top: -8px;
            }

            &:hover {
                color: var(--primary);
            }
        }

        &.is-opened {
            background-color: var(--secondary);
            color: var(--primary);

            i {
                color: var(--primary);
                content: '';
                background-color: var(--primary);
            }
        }

        &:hover,
        &:focus {
            background-color: var(--secondary);
            color: var(--color-button-hover);

            .title {
                color: var(--color-button-hover);
            }

            i {
                color: var(--color-button-hover);
            }
        }
    }

    span.text {
        font-size: 15px;
        float: right;
        margin-top: 6px;
        font-family: 'Roboto', 'sans serif' !important;
    }

    hr {
        border-top: 2px solid hsl(0deg 0% 100% / 10%) !important;
        margin: 1rem !important;
    }

    .sair-btn {
        text-align: center;
    }
}

.collapse-arrow {
    color: var(--white);
    text-align: right;
    font-size: 28px;
    margin: 0px 4px 8px 0px;
    cursor: pointer;
}

div.el-submenu__title > i.el-submenu__icon-arrow.el-icon-arrow-right {
    display: none;
}

.el-menu--collapse .el-submenu__title > span {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
}

.el-menu--vertical > ul {
    background-color: var(--primary) !important;
    border-radius: 5px;

    .el-menu-item {
        color: var(--white);
        border: 0px;
        margin: 2px 5px;
        // height: 47px !important;
        transition: all 0.1s ease-in-out;
        border-radius: 5px;
        display: flex;

        .title {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            line-height: 2px;

            span:not(:first-child) {
                margin: 2px;
                margin-top: -8px;
            }
        }

        i {
            color: var(--white);
            font-size: 40px;
            margin-right: 10px;
            margin-left: -3px;

            &:hover {
                color: var(--primary);
            }

            &::before {
                margin-top: 0px;
                margin-bottom: 5px;
            }
        }

        &:hover,
        &:focus {
            background-color: var(--secondary);
            color: var(--color-button-hover);

            i {
                color: var(--color-button-hover);
            }
        }

        &:hover i:before {
            background-color: var(--white) !important;
        }

        &.is-active {
            background-color: var(--secondary);
            color: var(--primary);

            i {
                color: var(--primary);
            }

            .lyra-icon::before {
                content: '';
                background-color: var(--primary);
            }
        }
    }
}

.hover-operacao {
    background-color: var(--secondary) !important;
    color: var(--color-button-hover) !important;
}
</style>
